<template>
  <div class="org-admin-dates_oad" :class="{ [curTheme]: true }">
    <div class="oaf_label">Дата или период</div>
    <div class="oad_date-wrap oad_date-wrap--1">
      с
      <el-date-picker
        v-model="dateStartLoc"
        :picker-options="dateStartOpts"
        type="date"
        class="oad_dates-input"
        @change="onChange"
        format="dd.MM.yyyy"
        value-format="timestamp"
        placeholder="Выберите дату...">
      </el-date-picker>
    </div>
    <div class="oad_date-wrap oad_date-wrap--2">
      по
      <el-date-picker
        v-model="dateEndLoc"
        :picker-options="dateEndOpts"
        type="date"
        class="oad_dates-input"
        @change="onChange"
        format="dd.MM.yyyy"
        value-format="timestamp"
        placeholder="Выберите дату...">
      </el-date-picker>
    </div>
    <div class="oad_btns">
      <button class="normal-button"
              @click="setDateFilter('today')">Сегодня</button>
      <button class="normal-button"
              @click="setDateFilter('yesterday')">Вчера</button>
      <button class="normal-button"
              @click="setDateFilter('week')">Неделя</button>
      <button class="normal-button"
              @click="setDateFilter('halfayear')">Полугодие</button>
      <button class="normal-button"
              @click="setDateFilter('year')">Год</button>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

let vm = null;

export default {

  props: ['dateStart', 'dateEnd'],

  data() {
    return {
      dateStartLoc: this.dateStart ? this.dateStart * 1000 : '',
      dateEndLoc: this.dateEnd ? this.dateEnd * 1000 : '',
      dateStartOpts: {
        disabledDate(time) {
          if (vm.dateEndLoc) {
            return time.getTime() > vm.dateEndLoc;
          }
          return false;
        },
      },
      dateEndOpts: {
        disabledDate(time) {
          if (vm.dateStartLoc) {
            return time.getTime() < (vm.dateStartLoc - (24 * 60 * 59 * 1000));
          }
          return false;
        },
      },
    };
  },

  created() {
    vm = this;
  },

  watch: {
    dateStart() {
      this.dateStartLoc = this.dateStart ? this.dateStart * 1000 : '';
    },
    dateEnd() {
      this.dateEndLoc = this.dateEnd ? this.dateEnd * 1000 : '';
    },
  },

  methods: {
    onChange() {
      this.$emit('update:dateStart', this.dateStartLoc
        ? Math.floor(this.dateStartLoc / 1000) : '');
      this.$emit('update:dateEnd', this.dateEndLoc
        ? Math.floor((this.dateEndLoc / 1000) + ((24 * 60 * 60) - 1)) : '');
    },
    setDateFilter(range) {
      if (range === 'today') {
        const todayTime = moment();
        this.dateStartLoc = todayTime;
        this.dateEndLoc = todayTime;
      } else if (range === 'yesterday') {
        const ydayTime = moment().subtract(1, 'day').valueOf();
        this.dateStartLoc = ydayTime;
        this.dateEndLoc = ydayTime;
      } else if (range === 'week') {
        this.dateStartLoc = moment().subtract(7, 'day').valueOf();
        this.dateEndLoc = moment().valueOf();
      } else if (range === 'halfayear') {
        this.dateStartLoc = moment().subtract(6, 'month').valueOf();
        this.dateEndLoc = moment().valueOf();
      } else if (range === 'year') {
        this.dateStartLoc = moment().subtract(1, 'year').valueOf();
        this.dateEndLoc = moment().valueOf();
      }
      this.onChange();
    },
  },

};
</script>

<style lang="scss">
@import '../../../styles/common/main';

.org-admin-dates_oad {
  .oad_date-wrap {
    text-align: center;
    display: inline;
    @media (max-width: 1100px) {
      .oad_dates-input.el-date-editor.el-input {
        width: 30%;
      }
    }
    @media (max-width: 440px) {
      display: block;
      .oad_dates-input.el-date-editor.el-input {
        width: 80%;
      }
      &.oad_date-wrap--1 {
        margin-bottom: 10px;
        .oad_dates-input.el-date-editor.el-input {
          display: inline-block;
          margin-left: 15px;
        }
      }
    }
  }
  .oad_dates-input.el-date-editor.el-input {
    width: 144px;
    display: inline-block;
    margin: 0 5px;
    .el-input__inner {
      height: 34px;
      padding-top: 3px;
      padding-left: 15px;
      padding-right: 15px;
      text-align: center;
      font-size: 15px;
      background: transparent;
      @include box-shadow(none);
      border: 1px solid rgba(215, 75, 130, .7);
      cursor: pointer;

    }
    .el-input.is-focus .el-input__inner {
      border-color: $color-2;
    }
    .el-input__prefix {
      display: none;
    }
    .el-input__suffix {
      top: -3px;
    }
  }
  .normal-button {
    padding-top: 7px;
    height: 36px;
    width: 110px;
    text-align: center;
    font-size: 15px;
    font-weight: 300;
    margin: 7px 0 7px 10px;
    text-transform: none;
    border-color: rgba(125, 125, 125, .5);
    &:hover {
      border-color: $color-1;
    }
  }
  .oad_btns {
    display: inline;
    @media (max-width: 1100px) {
      display: block;
      margin: 7px 0 0 7px;
    }
  }

  &.theme-w {
  }
}
</style>



// WEBPACK FOOTER //
// src/components/org-admin/inputs/OrgAdminDates.vue